/* global Promise */
export let GaEventMutator = (function() {
    function GaEventMutator() {
        this.init();
    }

    GaEventMutator.prototype = Object.assign({}, GaEventMutator.prototype, {
        init: function() {
            this.eventAction = { list: '' };
            this.eventKinds = {
                purchase: {
                    eventKey: 'Purchase_received',
                    eventDetail: 'purchase',
                    eventProductType: 'products',
                },
                refund: {
                    eventKey: 'refund',
                    eventProductType: 'products',
                },
                add_payment_info: {
                    eventKey: 'Checkout - Step 3',
                    eventDetail: 'checkout',
                    eventAction: { step: 3, action: 'checkout' },
                    eventProductType: 'products',
                },
                add_shipping_info: {
                    eventKey: 'Checkout - Step 2',
                    eventDetail: 'checkout',
                    eventAction: { step: 2, action: 'checkout' },
                    eventProductType: 'products',
                },
                view_cart: {
                    eventKey: 'Checkout - Step 1',
                    eventDetail: 'checkout',
                    eventAction: { step: 1, action: 'checkout' },
                    eventProductType: 'products',
                },
                add_to_cart: {
                    eventKey: 'addToCart',
                    eventDetail: 'add',
                    eventProductType: 'products',
                },
                remove_from_cart: {
                    eventKey: 'removeFromCart',
                    eventDetail: 'remove',
                    eventProductType: 'products',
                },
                view_item: {
                    eventKey: 'productView',
                    eventProductType: 'products',
                },

                select_item: {
                    eventKey: 'productClick',
                    eventDetail: 'click',
                    eventProductType: 'products',
                },
                view_promotion: {
                    eventKey: 'promoView',
                    eventDetail: 'promoView',
                    eventProductType: 'promotions',
                },
                select_promotion: {
                    eventKey: 'promotionClick',
                    eventProductType: 'promotions',
                },
            };
        },

        mutate: function(eventObj) {
            return new Promise((resolve, reject) => {
                let uaEvent = this.eventKinds[eventObj.event];
                if (!uaEvent) {
                    return;
                }
                if (uaEvent.eventKey === 'Purchase_received') {
                    this.eventAction = this._getEventAction(eventObj.ecommerce);
                } else {
                    this.eventAction = uaEvent.eventAction
                        ? uaEvent.eventAction
                        : undefined;
                }

                if (eventObj.ecommerce.items) {
                    let productDetailsArray = this._parseEventProducts(
                        eventObj.ecommerce.items
                    );

                    if (uaEvent.eventKey && productDetailsArray) {
                        this._buildUaEvent(
                            uaEvent.eventKey,
                            uaEvent.eventDetail,
                            uaEvent.eventProductType,
                            productDetailsArray
                        );
                        window.dataLayer.push(this.UaEvent);
                        resolve();
                    } else {
                        reject();
                    }
                }
            });
        },

        _getEventAction: function(eventObj) {
            return {
                id: eventObj.transaction_id
                    ? eventObj.transaction_id
                    : undefined,
                revenue: eventObj.value ? eventObj.value : undefined,
                tax: eventObj.tax ? eventObj.tax : undefined,
                shipping: eventObj.shipping ? eventObj.shipping : undefined,
                action: 'purchase',
            };
        },

        _parseEventProducts: function(eventProducts) {
            if (!eventProducts) {
                return [];
            }
            let products = [];
            eventProducts.forEach(evt => {
                if (evt.item_list_name) {
                    this.eventAction = this.eventAction || {};
                    this.eventAction.list = evt.item_list_name;
                }
                products.push({
                    position: evt.index ? evt.index : undefined,
                    id: evt.item_id ? evt.item_id : undefined,
                    name: evt.item_name ? evt.item_name : undefined,
                    price: evt.price ? evt.price : undefined,
                    brand: evt.item_brand ? evt.item_brand : undefined,
                    category: evt.item_category ? evt.item_category : undefined,
                    variant: evt.item_variant ? evt.item_variant : undefined,
                    quantity: evt.quantity ? evt.quantity : undefined,
                    dimension21: evt.dimension21 ? evt.dimension21 : 'null',
                    dimension20: evt.dimension20 ? evt.dimension20 : 'null',
                    dimension22: evt.dimension22 ? evt.dimension22 : 'null',
                    dimension23: evt.dimension23 ? evt.dimension23 : '',
                });
            });
            return products;
        },

        _buildUaEvent: function(
            eventKey,
            eventDetail,
            eventDetailType,
            productDetailsArray
        ) {
            this.UaEvent = {
                event: eventKey,
                ecommerce: {
                    [eventDetail]: {
                        [eventDetailType]: productDetailsArray,
                    },
                },
            };
            if (this.eventAction) {
                this.UaEvent.ecommerce[
                    Object.keys(this.UaEvent.ecommerce)[0]
                ].actionField = this.eventAction;
            }
        },
    });

    return GaEventMutator;
})();
